export default __webpack_public_path__ + "static/media/07.15.25 Minutes Spcl Mtg.1cdf887f.pdf";